// extracted by mini-css-extract-plugin
export default {"addressWrapper":"FormAddressAutoCompleteField_addressWrapper__udy97","suggestionsDropdown":"FormAddressAutoCompleteField_suggestionsDropdown__rYsiz"};